export default {
    shuffle(t) {
        var e = t.length - 1,
            i = 0,
            n = t[e];
        for (e; e > 0; e--)
            i = Math.floor(Math.random() * (e + 1)),
            n = t[e],
            t[e] = t[i],
            t[i] = n;
        return t
    },
    init() {
        var self = this;
        var brand = {
            init: function() {
                this.el = $(".js-brand-row"),
                this.cols = this.el.find(".js-brand-col"),
                this.stagger = null,
                this.delay = 2500,
                this.timeout = null,
                this.duration = 1500,
                this.colsRandom = null;
                this.cols.each(function(t, e) {
                    var col = $(this),
                        images = col.find(".js-brand-row__anim");
                    col.data({
                        index: 0,
                        length: images.length,
                        duration: 400,
                        animations: images,
                    }),
                    images.eq(0).addClass("is-active");
                });
                this.doTimeout();
            },
            onTransition: function(next, prev, duration) {
                var deferred = $.Deferred();
                prev.removeClass('is-active').addClass('is-exiting');
                next.addClass('is-entering');
                setTimeout(function() {
                    prev.removeClass('is-exiting');
                    next.removeClass('is-entering').addClass('is-active');
                    deferred.resolve();
                }, duration);
                return deferred.promise();
            },
            onStagger: function() {
                var self = this;
                var delay = this.delay;
                var steps = this.cols.length;
                function asyncEvent() {
                    var deferred = $.Deferred();
                    // Resolve after a random interval
                    setTimeout(function() {
                        for (var i = 0; i < steps; i++) {
                            var col = self.cols.eq(self.colsRandom.pop());
                            var data = col.data();
                            var animation = data.animations.eq(data.index);
                            if (data.index === data.length - 1) {
                                data.index = 0;
                            } else {
                                data.index++;
                            }
                            var transition = self.onTransition(data.animations.eq(data.index), animation, data.duration);
                            col.data(data);
                            $.when( transition ).then(
                                function() {
                                    deferred.resolve( "hurray" );
                                }
                            );
                        }
                    }, delay );
                    return deferred.promise();
                }
                $.when( asyncEvent() ).then(
                    function( status ) {
                        console.log( status + ", things are going well" );
                        self.doTimeout();
                    }
                );
            },
            doTimeout: function() {
                var colArray = $.makeArray( this.cols );
                this.colsRandom = self.shuffle(colArray.map(function(t, e) { return e })),
                this.timeout = setTimeout(this.onStagger(), this.duration);
            },
        };
        brand.init();
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/nosotros.js